import React from 'react';
import { Icon } from '@material-ui/core';
import icon from './icons8-external-link.svg';

const ExternalLinkIcon = ({ style }) => {
    return <Icon style={{ ...style }}>
        <img src={icon} height={20} width={20} style={{ color: 'gray' }} />
    </Icon>
}

export default ExternalLinkIcon
